import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { AILocationHintsEditor } from './AILocationHintsEditor';
import type { AnswerOptionCondition } from 'shared/types/due-diligence';

interface AIReferenceEditorProps {
  condition: AnswerOptionCondition;
  onUpdate: (updates: Partial<AnswerOptionCondition>) => void;
}

export function AIReferenceEditor({ condition, onUpdate }: AIReferenceEditorProps) {
  const handleReferenceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onUpdate({ aiReference: e.target.value });
  };

  const handleExpectedValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onUpdate({ aiExpectedValue: e.target.value });
  };

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="aiReference" className="text-sm font-medium">
          Referentie om te zoeken
        </Label>
        <Input
          id="aiReference"
          placeholder="bijv. 2024-VB-001234"
          value={condition.aiReference || ''}
          onChange={handleReferenceChange}
          className="text-sm"
        />
        <p className="text-xs text-muted-foreground">
          De exacte tekst, referentie of waarde die AI moet zoeken in het document.
        </p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="aiExpectedValue" className="text-sm font-medium">
          Verwachte waarde filter (optioneel)
        </Label>
        <Input
          id="aiExpectedValue"
          placeholder="Optioneel: verwachte waarde"
          value={condition.aiExpectedValue || ''}
          onChange={handleExpectedValueChange}
          className="text-sm"
        />
        <p className="text-xs text-muted-foreground">
          Als ingevuld, moet de gevonden waarde overeenkomen met deze filter.
        </p>
      </div>

      <AILocationHintsEditor condition={condition} onUpdate={onUpdate} />

      <div className="text-sm text-muted-foreground bg-muted/30 p-3 rounded-lg border border-border">
        <p className="font-medium mb-1">Uitleg:</p>
        <p>
          De AI zoekt naar de opgegeven referentie in het document. Als een verwachte waarde is opgegeven,
          moet de gevonden waarde daaraan voldoen. Gebruik locatie hints om de zoekgebied te beperken.
        </p>
      </div>
    </div>
  );
}
